// @ts-check
/** @jsxRuntime classic */
/** @jsx jsx */
import { graphql as gatsbyGraphQL } from 'gatsby';
import { jsx } from 'theme-ui';
import {
  PavilionCard,
  PremiumExhibitorCard,
  StandardExhibitorCard,
} from './VieVinumExhibitorCard';

export * from '@bottlebooks/gatsby-theme-event/src/components/ExhibitorsList/ExhibitorCard';

export default function ExhibitorCard({ exhibitor, ...rest }) {
  switch (exhibitor.exhibitorPackage?.key) {
    case 'premium':
      return (
        <PremiumExhibitorCard
          data={exhibitor}
          elevation={1}
          sx={(theme) => ({
            boxShadow: `0 0 0 1px ${theme.colors?.borderSecondary}`,
          })}
          {...rest}
        />
      );

    case 'pavilion':
      return (
        <PavilionCard
          data={exhibitor}
          elevation={1}
          sx={(theme) => ({
            boxShadow: `0 0 0 1px ${theme.colors?.borderSecondary}`,
          })}
          {...rest}
        />
      );

    default:
      return (
        <StandardExhibitorCard
          data={exhibitor}
          elevation={1}
          sx={(theme) => ({
            boxShadow: `0 0 0 1px ${theme.colors?.borderSecondary}`,
          })}
          {...rest}
        />
      );
  }
}

export const fragment = gatsbyGraphQL/* GraphQL */ `
  fragment vv_ExhibitorCard_Registration on Bottlebooks_SingleRegistration {
    registrationId
    exhibitorPackage: customFieldValue(key: "exhibitorPackage") {
      ... on Bottlebooks_SelectFieldValue {
        key
      }
    }
    ...VieVinumExhibitorCard_Registration
  }

  fragment vv_ExhibitorCard_AllData_Registration on Bottlebooks_SingleRegistration {
    exhibitorId: companyId
    ...bb_ExhibitorCard_Registration
    ...vv_ExhibitorCard_Registration
    profile {
      name
      countryName: country(format: LOCALIZED)
      stateProvince
      countryCode: country(format: RAW)
      region
      city
      logo {
        publicId
      }
    }
  }
`;
